import { render, staticRenderFns } from "./ShiftHistory.vue?vue&type=template&id=0c7507a3"
import script from "./ShiftHistory.vue?vue&type=script&lang=js"
export * from "./ShiftHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports